/* eslint-disable react/jsx-filename-extension */

import React from 'react';
import { Route } from 'react-router-dom';
import {
    NotFoundPage,
    MobileAuth,
    ProtectedRoute
} from 'sarsaparilla';

import PermitVenuePage from '../src/containers/PermitVenuePage';
import DivisionDetailsPage from '../src/containers/DivisionDetailsPage';
import QuestionnairePage from '../src/containers/QuestionnairePage';
import AvailabilityPage from '../src/containers/AvailabilityPage';
import PermitRegistrationPage from '../src/containers/PermitRegistrationPage';
import CartlessConfirmationPage from '../src/containers/CartlessConfirmationPage';
import TertiaryContentPage from '../src/containers/TertiaryContentPage';


import routesArray from './routesArray';

const Components = {
    PermitVenuePage,
    DivisionDetailsPage,
    QuestionnairePage,
    AvailabilityPage,
    PermitRegistrationPage,
    CartlessConfirmationPage,
    TertiaryContentPage
};

export default function makeSwitchRoutes() {
    const routeComponents = routesArray.map((route) => {
        const Component = Components[route.componentName];

        if (route.requireAuth) {
            return (
                <ProtectedRoute
                    key={route.path}
                    path={route.path}
                    component={Component}
                    exact={route.exact || false} />
            );
        }
        return (
            <Route
                key={route.path}
                path={route.path}
                component={Component}
                exact={route.exact || false} />
        );
    });

    // needed for mobile app to prevent login redirects
    routeComponents.push(
        <Route path="/permits/*/mobile/session" key="mobileSession" component={MobileAuth} />
    );

    routeComponents.push(
        <Route path="*" key="notFound" component={NotFoundPage} />
    );

    return routeComponents;
}

// import { MT_WHITNEY_PERMIT_ID, INYO_NF_PERMIT_ID } from '../src/utils/inyoUtils';

// Function was passed into onEnter:
// const validateRoute = (nextState, replace) => {
//     const { permitId } = nextState.params;
//     if ([MT_WHITNEY_PERMIT_ID, INYO_NF_PERMIT_ID].indexOf(permitId) === -1) {
//       replace("/invalid+permit+id");
//     }
// };